import { render } from "./productIntro.vue?vue&type=template&id=479e4340"
import script from "./productIntro.vue?vue&type=script&lang=js"
export * from "./productIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__